import { ArrowDropDown } from '@material-ui/icons';
import { Menu, MenuItem, Tooltip } from '@mui/material';
import { FC, useState, MouseEvent, CSSProperties } from 'react';

import { problemStore } from '../../../studentApp/stores';
import { OrderOption } from '../../../studentApp/types';
import { orderOptionsArray } from '../../../studentApp/utils';
import { REGION_LABEL_TEXT_COLOR } from '../../constants';

const sortByStyle: CSSProperties = {
  display: 'flex',
  marginLeft: 'auto',
  fontSize: '12px',
  fontWeight: 500,
  alignItems: 'center',
  color: REGION_LABEL_TEXT_COLOR,
};

export const OrderBy: FC = () => {
  const [orderBy, setOrderBy] = problemStore(state => [
    state.orderBy,
    state.setOrderBy,
  ]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (orderBy: OrderOption): (() => void) => () => {
    setOrderBy(orderBy);
    handleClose();
  };

  return (
    <div style={sortByStyle}>
      <span
        style={{
          fontWeight: 500,
          color: REGION_LABEL_TEXT_COLOR,
          marginRight: '6px',
        }}
      >
        Sort by
      </span>
      <Tooltip title="Change order of squares">
        <div
          onClick={handleClick}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            border: '1px solid',
            borderColor: REGION_LABEL_TEXT_COLOR,
            borderRadius: '8px',
            padding: '1px',
            backgroundColor: 'white',
          }}
        >
          <span
            style={{
              fontWeight: 800,
              marginLeft: '6px',
              color: REGION_LABEL_TEXT_COLOR,
            }}
          >
            {orderBy}
          </span>

          <ArrowDropDown />
        </div>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {orderOptionsArray.map(orderOption => (
          <MenuItem
            key={orderOption}
            onClick={handleMenuItemClick(orderOption)}
            disabled={orderOption === orderBy}
          >
            {orderOption}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
